import { render, staticRenderFns } from "./FormApplications.vue?vue&type=template&id=7bb997a4&scoped=true"
import script from "./FormApplications.vue?vue&type=script&lang=js"
export * from "./FormApplications.vue?vue&type=script&lang=js"
import style0 from "./FormApplications.vue?vue&type=style&index=0&id=7bb997a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb997a4",
  null
  
)

export default component.exports